import { Col } from 'antd';

import FitCulturalBar from './FitCulturalBar';
import Title from './Title';

interface TestFitCulturalProps {
  grade?: number;
}

const TestFitCultural: React.FC<TestFitCulturalProps> = ({ grade }) => {
  return (
    <Col>
      <Title
        title="Fit Cultural"
        tooltipText="Esse teste busca entender se o indivíduo e a empresa compartilham dos mesmos valores e concordam sobre o que é mais importante no ambiente profissional. As pessoas que têm um bom fit cultural com a organização em que trabalham, tendem a se sentirem mais felizes no dia-a-dia e a permanecer mais tempo na empresa."
      />
      <FitCulturalBar grade={grade} />
    </Col>
  );
};

export default TestFitCultural;
